import script from "./CellComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CellComponent.vue?vue&type=script&setup=true&lang=js"

import "./CellComponent.vue?vue&type=style&index=0&id=90b13c64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\killi\\WebstormProjects\\chess_vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90b13c64"]])

export default __exports__